import React from 'react';
import { HeroPartner } from './HeroPartner';
import { WhyPartner } from './WhyPartner';
import { ContactForm } from './ContactForm';

const PartnerNew = () => (
  <div style={{ backgroundColor: '#fff' }}>
    <HeroPartner />
    <ContactForm />
    <WhyPartner />
  </div>
);

export default PartnerNew;
